<template>
    <div v-if="terms">
        <div class="join-row" v-if="mode == 'join'">
            <div class="join-caption">
                <h3 class="title">{{ terms.subject }}</h3>
                <label class="check">
                    <input v-model="value" class="input" type="checkbox">
                    <i class="icon"></i>
                    <span class="text">동의</span>
                </label>
            </div>
            <div class="join-box">
                <textarea class="textarea" name="terms" readonly v-model="terms.content" />
            </div>
        </div>

        <!-- <div v-else v-html="terms.content.replace(/\n/gi,'<br>')">

        </div> -->
        <textarea v-else class="textarea" name="terms" readonly v-model="terms.content" />
    </div>

</template>

<script>
export default {
    props: {
        code: { type: String, default: null },
        mode: { type: String, default: "join" }
    },
    data: () => {
        return {
            terms: null,
            value: false,
        }
    },
    created(){
        this.init();
    },
    methods: {
        async init(){
            try{
                await this.getTerms();
            }
            catch(error){
                console.error(error);
            }
        },
        getTerms(){
            return new Promise(async (resolve, reject) => {
                try{
                    var res = await this.$http.get(`/api/v1/terms/${this.code}`);

                    this.terms = res.data.terms;
                    resolve();
                }
                catch(error){
                    reject(error);
                }
            });
        }
    },
    watch: {
        value(){
            this.$emit('change', this.value);
        }
    }
}
</script>
